import { useMapped } from "@omni/utils/context/mapped.context";
import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { AutocompleteItem } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/AutocompleteItem/autocompleteItem";
import { useResults } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/context/results.context";
import { Highlight } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/Highlight/highlight.component";
import { QUERY_SUGGESTIONS_SOURCE_ID } from "@/components/Search/SearchBar/config/searchBar.config";
import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";
import { getRedirectUrlFromState } from "@/components/Search/SearchBar/helpers/redirect.helpers";

type Props = {
    className?: string;
};

export const Item = ({ className }: Props) => {
    const { items } = useResults(QUERY_SUGGESTIONS_SOURCE_ID);
    const { autocompleteState, autocompleteActions } = useSearchBarContext();
    const { index } = useMapped();

    const item = items[index];

    return (
        <AutocompleteItem
            query={item.query}
            className={cn("tw:flex tw:rounded-sm", className)}
            itemId={item.__autocomplete_id}
            autocompleteState={autocompleteState}
            autocompleteActions={autocompleteActions}
            getRedirectUrl={() =>
                isDefined(autocompleteState)
                    ? getRedirectUrlFromState(autocompleteState)
                    : undefined
            }
        >
            <div>
                <i className={cn("las la-search", "tw:pr-2")} />
            </div>
            <Highlight
                highlightMatch={item._highlightResult.query}
                reverseHighlight={true}
            />
        </AutocompleteItem>
    );
};
